// Centralized client-side configuration.
//
// Key goals:
// - In development, prefer relative API calls + CRA proxy to avoid CORS.
// - In production, default to the real API host.
// - Never ship a hardcoded API key in the bundle.

const DEFAULT_SERVER_URL =
  process.env.NODE_ENV === 'development'
    ? ''
    : 'https://api.financetgts.com';

export const API_KEY = process.env.REACT_APP_API_KEY || null;

const envServerUrl = process.env.REACT_APP_SERVER_URL;
export const SERVER_URL =
  envServerUrl && envServerUrl.trim() ? envServerUrl.trim() : DEFAULT_SERVER_URL;
